import { OAuth } from '@tunasong/redux'
import React, { useCallback } from 'react'
import type { FC } from 'react'

export interface SignupButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const SignupButton: FC<SignupButtonProps> = props => {
  const { className, ...restProps } = props
  const handleClick = useCallback(() => {
    OAuth.authorize({ signup: true })
  }, [])
  return (
    <button
      className={`${className} className="px-8  bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300" rounded-md bg-blue-700 hover:bg-blue-900 px-6 py-3 hover:cursor-pointer `}
      onClick={handleClick}
      {...restProps}
    >
      Sign up
    </button>
  )
}

export default SignupButton
